import { Text, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EventListItemDto } from "../../autogen/bff-api";
import { useDisplayDate } from "../../common/formatting/useDisplayDate";
import { listItemIsDraft } from "./eventStatusFilters";

export const CopiedFromLine = ({ event }: { event: EventListItemDto }) => {
  const { t } = useTranslation();
  const displayDate = useDisplayDate();
  if (!event.copiedFrom || !listItemIsDraft(event)) return null;
  const line = t("Copied {{date}} from «{{title}}»", {
    date: displayDate(event.copiedFrom.copiedAt),
    title: event.copiedFrom.title || t("Untitled"),
  });
  return (
    <Tooltip label={line}>
      <Text fontSize="xs" color="smMuted" noOfLines={1}>
        {line}
      </Text>
    </Tooltip>
  );
};
